import { render, staticRenderFns } from "./FrzPackingBagSealedDetail.vue?vue&type=template&id=e253f3a4"
import script from "./FrzPackingBagSealedDetail.vue?vue&type=script&lang=js"
export * from "./FrzPackingBagSealedDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports